import { createSelector } from "reselect";

export const schedulerStatisticSelector = createSelector(
    state => state.scheduler.statistic,
    state => state
);